import { Component, OnInit, OnDestroy, ViewChildren, QueryList, ViewChild, AfterViewInit } from '@angular/core';
import { AuctionFilter } from '../../models/auction-filter';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { DistributorFilter } from '../../models/distributor-filter';
import { environment } from '../../../../../environments/environment';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}


@Component({
  selector: 'app-home-main-modal-logist',
  templateUrl: './home-main-modal-logist.component.html',
  styleUrls: ['./home-main-modal-logist.component.sass']
})
export class HomeMainModalLogistComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];


  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('nameInput') nameInputModel: QueryList<any>;

  checkedDistributerLogist: number[];

  dt: DataTables.Api;
  modelDistributorFilter: DistributorFilter = new DistributorFilter();
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  dtOptionsDistributorLogists: DataTables.Settings = {};
  dataSetDistributors: any;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private loggingService: LoggingService) {
    this.checkedDistributerLogist = [];
  }

  ngOnInit() {

    this.subs.push(this.bus.currentClearModalFilter$.subscribe(key => {
      if (key === 'distrLogist') {
        this.nameInputModel.forEach(function (item) {
          item.nativeElement.checked = false;
        });
        this.checkedDistributerLogist = [];
        this.onAuctionFilter('logist');
      }
    }));


    this.subs.push(this.bus.currentClearSearchModalFields$.subscribe(key => {
      if (key === 'modalDistributorLogist') {
        console.log(key);
        this.modelDistributorFilter.name = null;
        this.onFieldChange();
      }
    }));

    const that = this;
    this.dtOptionsDistributorLogists = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      deferLoading: 0,
      // scrollY: '400px',
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        dataTablesParameters.search = this.modelDistributorFilter.name;

        that.http.post<DataTablesResponse>(`${apiServer}/distributor`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetDistributors = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        { orderable: false },
        { data: 'distrName', name: 'distrName' },
      ]
    };

  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onFieldChange() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalLogistComponent.onFieldChange', null, 'Field change started');
      
      this.dt.ajax.reload();
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalLogistComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalLogistComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  onSelectedRowLogist(event, value) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalLogistComponent.onSelectedRowLogist', null, 'Row selection started');
      
      if (event.target.checked) {
        this.checkedDistributerLogist.push(value);
      } else {
        for (let i = 0; i < this.checkedDistributerLogist.length; i++) {
          if (this.checkedDistributerLogist[i] === value) {
            this.checkedDistributerLogist.splice(i, 1);
          }
        }
      }
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalLogistComponent.onSelectedRowLogist', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalLogistComponent.onSelectedRowLogist', _error, null, 'Row selection failed');
      throw _error;
    }
  }
  onSelectingRowsLogist(event) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalLogistComponent.onSelectingRowsLogist', null, 'Selecting all rows started');
      
      const that = this;

      this.nameInputModel.forEach(function (item) {
        item.nativeElement.checked = event.target.checked;

        if (event.target.checked) {
          that.checkedDistributerLogist.push(item.nativeElement.value);
        } else {
          for (let i = 0; i < that.checkedDistributerLogist.length; i++) {
            if (that.checkedDistributerLogist[i] === item.nativeElement.value) {
              that.checkedDistributerLogist.splice(i, 1);
            }
          }
        }
      });
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalLogistComponent.onSelectingRowsLogist', null, 'Selecting all rows completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalLogistComponent.onSelectingRowsLogist', _error, null, 'Selecting all rows failed');
      throw _error;
    }
  }

  onAuctionFilter(selectedType: string) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalLogistComponent.onAuctionFilter', null, 'Auction filter started');
      
      switch (selectedType) {
        case 'logist':
          {
            this.modelAuctionFilter.distrLogist = this.checkedDistributerLogist.join(",");
            break;
          }
      }
      this.bus.changeFilter(this.modelAuctionFilter);
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalLogistComponent.onAuctionFilter', null, 'Auction filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalLogistComponent.onAuctionFilter', _error, null, 'Auction filter failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-logist/home-main-modal-logist.component.ts